import type { IUserInfo } from "../types"

/**
 * Возвращает информацию о пользователе из локального хранилища
 */
export function getUserInfo(): IUserInfo | null {
	const userInfo = localStorage.getItem("userInfo")
	return userInfo && JSON.parse(userInfo)
}
